export default __webpack_public_path__ + "static/media/swimrun-01.02c5755c.svg";